<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-md-6 text-center">
      <div class="mb-4">
        <img
          [src]="
            (module.corporation$ | async)?.logoMedia?.url ||
            'assets/images/brands/tsolife-logo-200x45.svg'
          "
          height="80" />
      </div>
      <h5 class="mb-4">
        Thank you! Congratulations on your new move-in! <br />
        An email with a PDF summary of your responses will immediately be
        emailed
        <ng-container *ngIf="migFormData">
          to
          <button disabled class="btn btn-sm btn-soft-primary">
            {{ migFormData.email }}
          </button>
        </ng-container>
      </h5>
      <h5 class="mb-4">
        If you have any questions, please email
        <a href="mailto:support@tsolife.com"> support@tsolife.com </a>
      </h5>
      <h5 class="mb-4">
        Click below to submit a form for another new resident
      </h5>
      <a
        class="btn btn-primary fw-bold"
        [routerLink]="['/mig-form', this.module.corporation$.value?.code]">
        Submit Another Form
      </a>
    </div>
  </div>
</div>
